/**
 * @generated SignedSource<<0709c15c88e3111d514fb33ce5d6ff79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoTimelineUpdateEventEmployee_employee$data = {
  readonly name: string;
  readonly " $fragmentType": "TodoTimelineUpdateEventEmployee_employee";
};
export type TodoTimelineUpdateEventEmployee_employee$key = {
  readonly " $data"?: TodoTimelineUpdateEventEmployee_employee$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEventEmployee_employee">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoTimelineUpdateEventEmployee_employee",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "Employee",
  "abstractKey": null
};

(node as any).hash = "b587e9e91ef65fd224e73fa23405b233";

export default node;
